import { render, staticRenderFns } from "./UnrankedPortfolioConfirmationDrawer.vue?vue&type=template&id=96432074&scoped=true"
import script from "./UnrankedPortfolioConfirmationDrawer.vue?vue&type=script&lang=js"
export * from "./UnrankedPortfolioConfirmationDrawer.vue?vue&type=script&lang=js"
import style0 from "./UnrankedPortfolioConfirmationDrawer.vue?vue&type=style&index=0&id=96432074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96432074",
  null
  
)

export default component.exports